"use client";
import { store, persistor } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import React from "react";

export function ReduxProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider data-component-id="src/redux/provider.tsx:9:4" data-component-path="src/redux/provider.tsx" data-component-line="9" data-component-file="provider.tsx" data-component-name="Provider" data-component-content="%7B%22elementName%22%3A%22Provider%22%7D" store={store}>
      <PersistGate data-component-id="src/redux/provider.tsx:10:6" data-component-path="src/redux/provider.tsx" data-component-line="10" data-component-file="provider.tsx" data-component-name="PersistGate" data-component-content="%7B%22elementName%22%3A%22PersistGate%22%7D" loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
}
